var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1666 3.34338H13.5583L13.0583 1.42672V1.33505C12.7498 0.532463 11.9765 0.00478497 11.1166 0.0100488H8.94165C8.0818 0.00478497 7.30854 0.532463 6.99998 1.33505L6.46665 3.34338H0.833313V5.01005H2.49998V17.9267C2.49998 19.0773 3.43272 20.01 4.58331 20.01H15.4166C16.5672 20.01 17.5 19.0773 17.5 17.9267V5.01005H19.1666V3.34338ZM8.53331 1.91005C8.60342 1.76697 8.74898 1.6764 8.90831 1.67672H11.0833C11.2426 1.6764 11.3882 1.76697 11.4583 1.91005L11.8333 3.34338H8.15831L8.53331 1.91005ZM15.4166 18.3434C15.6468 18.3434 15.8333 18.1568 15.8333 17.9267V5.01005H4.16665V17.9267C4.16665 18.1568 4.35319 18.3434 4.58331 18.3434H15.4166ZM6.66665 7.51005H8.33331V15.8434H6.66665V7.51005ZM13.3333 7.51005H11.6666V15.8434H13.3333V7.51005Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.74497422fd6d67300b60aa447fde58d1.svg";
export { ForwardRef as ReactComponent };